import React, { useContext, useEffect, useState } from 'react'
import { ShippingMethodSelector, Spinner } from '@pinflag/pinflag-ui-kit'
import { DataContext } from '../../context/DataContext'
import { useApiPinflag } from '../../hook/useApiPinflag'
import AddressTypeInputSelector from './AddressTypeInputSelector'
import PickupMap from './PickupMap'
import { CUSTOM_STORES_NAME, CHANGE_ORDER, ONLY_CHECKOUT } from '../../constants/stores'
import { useCmsAdapter } from '../../hook/useCmsAdapter'

const ShippingOptionRenderer = () => {
  const [isLoading, setIsLoading] = useState(true)
  const {
    steps,
    setSteps,
    pointsData,
    selectedShippingMethod,
    setSelectedShippingMethod,
    setIsPickup,
    setIsPaying,
    companyInfo,
    ecommerceInfo
  } = useContext(DataContext)
  const { primaryColor, secondaryColor, companyName } = companyInfo
  const { getPoints } = useApiPinflag()
  const { localPoints, pinflagPoints } = pointsData
  const areDisabled = {
    localPickup: !localPoints.length,
    cnc: !pinflagPoints.length,
    homeDelivery: false
  }
  const badge = {
    localPickup: companyInfo.storePickupPriceLabel,
    cnc: companyInfo.ccDiscountPercentageLabel,
    homeDelivery: ''
  }
  const buttonsTitle = {
    localPickup: 'Retiro en ' + companyInfo.storePickupTypeLabel ? companyInfo.storePickupTypeLabel : 'Tienda',
    cnc: 'Retiro en Punto',
    homeDelivery: 'Despacho a Domicilio'
  }

  const { postTrackingEvent } = useCmsAdapter()

  const handleClick = option => {
    const updatedSteps = [...steps]
    updatedSteps[0].completed = true
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = true
    setSteps(updatedSteps)
    setSelectedShippingMethod(option)
    postTrackingEvent(`click - ${option}`, {
      currentCheckoutSubstep: '1',
      previousCheckoutStep: '1'
    })
  }

  const redirection = () => {
    const updatedSteps = [...steps]
    updatedSteps[0].completed = true
    updatedSteps[1].disabled = false
    updatedSteps[1].subSteps[0].completed = true
    setSteps(updatedSteps)
    setSelectedShippingMethod('home-delivery')
    postTrackingEvent('click - home-delivery', {
      currentCheckoutSubstep: '1',
      previousCheckoutStep: '1'
    })
  }

  useEffect(() => {
    setIsPickup(false)
    if (companyInfo.companyName === 'Epic') { setIsPickup(true) }
    postTrackingEvent('impression', {
      currentCheckoutSubstep: '1',
      previousCheckoutStep: '1'
    })
    if (!localPoints.length && !pinflagPoints.length) {
      getPoints(setIsLoading)
    } else {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!isLoading && areDisabled.cnc && areDisabled.localPickup) {
      !ONLY_CHECKOUT.includes(companyName) && redirection()
    }
  }, [isLoading])

  if (isLoading) {
    return (
      <div className='full_width_spinner md:w-[537px]'>
        <div className='md:flex md:justify-center'>
          <Spinner width={44} />
        </div>
      </div>
    )
  }

  return (
    <>
      {!selectedShippingMethod
        ? (
          <ShippingMethodSelector
            areDisabled={areDisabled}
            handleButtonClick={handleClick}
            companyName={CUSTOM_STORES_NAME[companyName] || companyName}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            badge={badge}
            areColorsInverted={ecommerceInfo.cms === 'woocommerce'}
            isCncDisabled={
              companyName === "L'Occitane" ||
              companyName === 'Safety Store B2B' ||
              companyName === 'SELFIE' ||
              companyName === 'Opaline' ||
              companyName === 'Colloky'
            }
            isLocalPickupDisabled={
              companyName === 'Safety Store B2B'
            }
            buttonsTitle={buttonsTitle}
            changeOrder={CHANGE_ORDER.includes(companyName)}
          />
          )
        : selectedShippingMethod === 'home-delivery'
          ? (
            <AddressTypeInputSelector setIsPaying={setIsPaying} />
            )
          : (
            <PickupMap />
            )}
    </>
  )
}

export default ShippingOptionRenderer
